module.exports = __webpack_public_path__ + "img/notFound.97ab2e30.png";